import { render, staticRenderFns } from "./TableView.vue?vue&type=template&id=28250c12&scoped=true&"
import script from "./TableView.vue?vue&type=script&lang=ts&"
export * from "./TableView.vue?vue&type=script&lang=ts&"
import style0 from "./TableView.vue?vue&type=style&index=0&id=28250c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28250c12",
  null
  
)

component.options.__file = "TableView.vue"
export default component.exports